/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Umbrella(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M239.61328,126.62988A112.0108,112.0108,0,0,0,128.00684,24h-.01368A112.0108,112.0108,0,0,0,16.38672,126.62988,16.02123,16.02123,0,0,0,32.33447,144H120v56a32,32,0,0,0,64,0,8,8,0,0,0-16,0,16,16,0,0,1-32,0V144h87.66553a16.02123,16.02123,0,0,0,15.94775-17.37012ZM32.332,127.95215a95.97942,95.97942,0,0,1,75.85645-85.874C96.47266,58.05713,81.84521,86.12988,80.16553,128H32.33447ZM175.83447,128c-1.67968-41.87012-16.30713-69.94287-28.023-85.92188A95.96509,95.96509,0,0,1,223.66553,128Z" />
    </Svg>
  );
}

export default Umbrella;
